SppHandler = App.loadClass 'grower::handlers/placement/SppHandler'

class exports.LegendEDGEHandler extends SppHandler

    init: () ->

        # note that @ is the SPP Handler, not the Step Handler
        @customStepFunctions =

            step_3:
                afterEnter: @stepFunctions.addMaturityValidation


        @hybridButtonContents =
            title: 'seed_company_name'
            table:
                'Brand': 'display_name'
                # 'Trait': 'trait_summary' Removed due to client not giving us any data to populate this with
                'RM': 'relative_maturity'
            text: [
                'talking_points_line_1'
            ]


        @customButton =
            'html': '<button class="btn btn-primary" id="pdf_button" data-loading-text="Generating report...">
                    <i class="fa fa-file-o"></i> Summary Report
                </button>'
            'click': () =>
                layers = @curStep.stepKO.plantingPlans()
                @actionPdf(layers)

        # LEVEL UP!
        super()

    # This function will be passed into the Planting dialog controller via
    # PlantingOptions. "plan" is the Layer model used for the Plan tab.
    # "notes_obj" is the object used by the Notes tab.
    customPlantingPlan: (field_id, plan, notes_obj) =>
        products = @taffyObjects.hybrids

        @_customProductSubscription = (stage, product_id) ->
            product = products(id: parseInt(product_id)).first()
            stage.treatment = product?.default_treatment_id

            notesFn()

        notesFn = () ->
            notes = ''
            for event in plan.events
                for stage in event.stages
                    product = products(id: parseInt(stage.product?.id)).first()
                    if not product?
                        continue

                    notes += product.display_name
                    url = product.tech_sheet_url
                    notes += " (<a href='#{url}'>#{url}</a>)" if url
                    notes += '<br>'

                    if product.description
                        notes += product.description + '<br/>'

            notes_obj.notes = notes
